import { Routes } from '@angular/router';
import { AuthGuard } from '@app/auth/services/auth-guard.service';
import { StatusGuard } from '@app/auth/services/status-guard.service';
import { AdminStatusGuard } from './auth/services/admin-guard.service';
const ɵ0 = () => import("./pages/dashboard/dashboard.module.ngfactory").then(m => m.DashboardModuleNgFactory), ɵ1 = () => import("./pages/admin/admin.module.ngfactory").then(m => m.AdminModuleNgFactory), ɵ2 = () => import("./pages/traffic-analysis/traffic-analysis.module.ngfactory").then(m => m.TrafficAnalysisModuleNgFactory), ɵ3 = () => import("./pages/catalogue/catalogue.module.ngfactory").then(m => m.CatalogueModuleNgFactory), ɵ4 = () => import("./pages/offers/offers.module.ngfactory").then(m => m.OffersModuleNgFactory), ɵ5 = () => import("./pages/translations/translations.module.ngfactory").then(m => m.TranslationsModuleNgFactory), ɵ6 = () => import("./pages/search/search.module.ngfactory").then(m => m.SearchModuleNgFactory), ɵ7 = () => import("./pages/group/group.module.ngfactory").then(m => m.GroupModuleNgFactory), ɵ8 = () => import("./pages/users/users.module.ngfactory").then(m => m.UsersModuleNgFactory), ɵ9 = () => import("./pages/tecdoc/tecdoc.module.ngfactory").then(m => m.TecdocModuleNgFactory), ɵ10 = () => import("./pages/tecdoc-car-bus/tecdoc.module.ngfactory").then(m => m.TecdocCarBusModuleNgFactory), ɵ11 = () => import("./pages/cart/cart.module.ngfactory").then(m => m.CartModuleNgFactory), ɵ12 = () => import("./pages/checkout/checkout.module.ngfactory").then(m => m.CheckoutModuleNgFactory), ɵ13 = () => import("./pages/profile/profile.module.ngfactory").then(m => m.ProfileModuleNgFactory), ɵ14 = () => import("./pages/cookies-policy/cookies-policy.module.ngfactory").then(m => m.CookiesPolicyModuleNgFactory), ɵ15 = () => import("./pages/user-manual/user-manual.module.ngfactory").then(m => m.UserManualModuleNgFactory), ɵ16 = () => import("./pages/test/test.module.ngfactory").then(m => m.TestModuleNgFactory), ɵ17 = () => import("./pages/custom-page/custom-page.module.ngfactory").then(m => m.CustomPageModuleNgFactory), ɵ18 = () => import("./pages/truck-catalog/truck-catalog.module.ngfactory").then(m => m.TruckCatalogModuleNgFactory), ɵ19 = () => import("./pages/custom-emails/custom-emails.module.ngfactory").then(m => m.CustomEmailsModuleNgFactory), ɵ20 = () => import("./pages/cookies-disabled-notice/cookies-disabled-notice.module.ngfactory")
    .then(m => m.CookiesDisabledNoticeModuleNgFactory), ɵ21 = () => import("./pages/skuba-notifications/skuba-notifications.module.ngfactory").then(m => m.SkubaNotificationsModuleNgFactory), ɵ22 = () => import("./pages/banners/banners.module.ngfactory").then(m => m.BannersModuleNgFactory);
/**
 * Parent routes for the {@link AppRoutingModule}
 */
const routes = [
    {
        path: 'dashboard',
        loadChildren: ɵ0,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'admin',
        loadChildren: ɵ1,
        canActivate: [AuthGuard, StatusGuard, AdminStatusGuard]
    },
    {
        path: 'traffic-analysis',
        loadChildren: ɵ2,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'catalogue',
        loadChildren: ɵ3,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'offers',
        loadChildren: ɵ4,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'translations',
        loadChildren: ɵ5,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'search',
        loadChildren: ɵ6,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'group',
        loadChildren: ɵ7,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'users',
        loadChildren: ɵ8,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'tecdoc',
        loadChildren: ɵ9,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'tecdoc-car-bus',
        loadChildren: ɵ10,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'cart',
        loadChildren: ɵ11,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'checkout',
        loadChildren: ɵ12,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'profile',
        loadChildren: ɵ13,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'cookies-policy',
        loadChildren: ɵ14,
        canActivate: [AuthGuard]
    },
    {
        path: 'user-manual',
        loadChildren: ɵ15,
        canActivate: [AuthGuard]
    },
    {
        path: 'test',
        loadChildren: ɵ16,
        canActivate: [AuthGuard, AdminStatusGuard]
    },
    {
        path: 'page',
        loadChildren: ɵ17,
        canActivate: [AuthGuard]
    },
    {
        path: 'truck-catalog',
        loadChildren: ɵ18,
        canActivate: [AuthGuard, StatusGuard]
    },
    {
        path: 'custom-emails',
        loadChildren: ɵ19,
        canActivate: [AuthGuard, AdminStatusGuard]
    },
    {
        path: 'cookies-disabled',
        loadChildren: ɵ20
    },
    {
        path: 'skuba-notifications',
        loadChildren: ɵ21
    },
    {
        path: 'banners',
        loadChildren: ɵ22,
        canActivate: [AuthGuard, StatusGuard]
    },
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
];
/**
 * @whatItDoes The {@link AppRoutingModule} is a
 * [Routing Module](https://angular.io/docs/ts/latest/guide/router.html#routing-module) that
 * handles the app's routing concerns.
 * @consumers {@link AppModule}
 * @see [Angular 2 docs - Lazy loading modules with the Router]
 * (https://angular.io/docs/ts/latest/guide/ngmodule.html#lazy-load)
 *
 * The returned {@link AppRoutingModule} class is a Routing Module containing both the RouterModule
 * directives and the Dependency Injection providers that produce a configured Router.
 */
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22 };
